import React, {Component} from 'react';
import {LayoutSidebar} from "../../Layout";
import {UserSettings} from "./UserSettings";
import {withRouterParams} from "../../utils/withRouterParams";

class UserConfiguration extends Component {
    render() {
        return (
            <div className="app-content">
                <LayoutSidebar/>
                <UserSettings userId={this.props.match.params.id}/>
            </div>
        )
    }
}

export default withRouterParams(UserConfiguration);

